import { trimObjectStrings } from '../utils/stringUtils';
import { buildPortsFormData } from '../utils/format';
import { logout } from './Security/securityReducer';
import { backendFetch } from '../api/apiUtils';

const url = process.env.REACT_APP_API;
const reporturl = process.env.REACT_APP_REPORT;
const urlForVerifyOneTimePassword = url + 'verifyOtp';
const urlForRequestNewOneTimePassword = url + 'resendOtp';
const urlForAddUser = url + 'addUser';
const urlForCompanys = url + 'companies';
const urlForinvoiceSearch = url + 'invoices';
const urlForinvoiceDetails = url + 'invoicedetails?invoice=';
const urlForTeamMembers = url + 'teammembers/';
const urlFroValidateEORI = url + 'eori?eori=';
const urlForValidateVAT = url + 'vat?eori=';
const urlForNeeNor = url + 'neenor/';
const urlForNeeNorDetails = url + 'neenor/details?id=';
const urlForNewLoad = url + 'newload/';
const urlForMasterData = url + 'masterdata/';
const urlForProductdata = url + 'productdata';
const urlForProducts = url + 'products';
const urlForPruductsDetails = url + 'products/details?id=';
const urlForCompanyProducts = url + 'newload/products';
const urlFroValidateProduct = url + 'products/validate?product=';
const urlForReports = url + 'reports/';
const urlForUserAdmin = url + 'useradmin/';
const urlForUserDetails = url + 'useradmin/details?userid=';
const urlForTeamMemberDetails = url + 'teammembers/details?id=';
const urlForListLoads = url + 'listload/';
const urlForFileUpload = url + 'fileUpload/';
const urlForForgottenpassword = url + 'forgottenpassword/';
const urlForEIDR = url + 'eidr?id=';
const urlForSDI = url + 'descartes/sdi';
const urlForSFD = url + 'descartes/sfd';
const urlForFFD = url + 'descartes/ffd';
const urlForC21 = url + 'descartes/c21';
const urlForEAD = url + 'descartes/ead';
const urlForMaintenance = url + 'maintenance/';
const urlForCustomerData = url + 'customerdata';
const urlForAdditionalFileUpload = url + 'additionalFileUpload/add';
const urlForAdditionalFileDelete = url + 'additionalFileUpload/delete';
const urlForAdditionalFileNames = url + 'additionalFileUpload/get';
const urlForAdditionalFileData = url + 'additionalFileUpload/getData';
const urlForDocumentTypes = url + 'documentTypes';
const urlForOrderForm = url + 'orderform';
const urlForCommodityInfo = url + 'commCodeInfo';
const urlForMeasuresInfo = url + 'measuresInfo';
const urlForCountryInfo = url + 'countryInfo';
const urlForEPOData = url + 'EPO/';
const urlForDocusign = url + 'docusign/generatePage';
const urlForRegistration = url + 'registration/';
const urlForAdditionalEPOFileUpload = url + 'EPO/AddInvoice';
const urlForGATrackingCode = url + 'gaTrackingCode';
const urlForLspAccess = url + 'lspAccess/';
const urlForWLP = url + 'whitelabel/';
const urlForCompanyList = url + 'useradmin/companyList';
const urlForReportList = reporturl + 'reports/';
const urlForSelectedReport = reporturl + 'it/';
const urlForCommcode = url + 'commcode/';
const urlForReportDashboard = reporturl + 'dashboard/';
const urlBusinessPartner = url + 'businessPartner/';
const urlForBusinessPartnerAddNote = url + 'businessPartner/addNote';
const urlForBusinessPartnerGetNotes = url + 'businessPartner/getNotes?id=';
const urlForBusinessPartnerDeleteNote = url + 'businessPartner/deleteNote?id={id}&customerId={customerId}';
const urlForCustomaite = url + 'customaite/';
const urlForCustomsTech = url + 'commCodeCustomsRules/';
const urlForVatAuth = url + 'vatAuth/';
const urlForSupplementaryUnits = url + 'newload/commoditySupplementaryUnits';
const urlForIpaffsRisk = url + 'ipaffsRisk/';
const urlForOrderFormMasterData = url + 'orderFormRules/';
const urlForAppSettings = url + 'appSettings/';

export const getIpaffsCategories = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForIpaffsRisk + 'commCodeCategories', {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postIpaffsCategories = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForIpaffsRisk + 'commCodeCategories', {
    method: 'POST',
    headers: header,
    body: data,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postOrderFormsMasterDataDownloadFile = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForOrderFormMasterData + 'fileDownload', {
    method: 'POST',
    headers: header,
    body: data,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postIpaffsDownloadFile = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForIpaffsRisk + 'fileDownload', {
    method: 'POST',
    headers: header,
    body: data,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postOrderFormsRulesDocument = async (formData) => {
  const token = sessionStorage.getItem('token');

  const response = await fetch(`${urlForOrderFormMasterData}fileUpload`, {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `${token}`,
    },
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postIpaffsDocument = async (formData) => {
  const token = sessionStorage.getItem('token');

  const response = await fetch(`${urlForIpaffsRisk}fileUpload`, {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `${token}`,
    },
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const PostOrderFormsMasterDataSearch = async (submit) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForOrderFormMasterData + 'searchLazy', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(submit),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postOrderFormsMasterDataFilesLazy = async (submit) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForOrderFormMasterData + 'filesSearchLazy', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(submit),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const ipaffsVersionLazy = async (submit) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForIpaffsRisk + 'versionSearchLazy', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(submit),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const ipaffsLazy = async (submit) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForIpaffsRisk + 'searchlazy', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(submit),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getQAPersistedData = async (loadId) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForNewLoad + 'qadata?loadId=' + loadId, {
    method: 'GET',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postCommCodeRules = async (data, isEditing) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'content-type': 'application/json',
  };

  const endpoint = `${urlForCustomsTech}postcustomrules?isediting=${isEditing}`;
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: header,
    body: JSON.stringify(data),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getAppVersion = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForAppSettings + 'version', {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const setAppVersion = async (versionNumber) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForAppSettings + 'version', {
    method: 'POST',
    headers: header,
    body: JSON.stringify({ versionNumber }),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const commCodeRulesSearchLazy = async (submit) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForCustomsTech + 'searchlazy', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(submit),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postCheckPreferentialValidation = async (formData) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };

  const endpoint = `${urlForNewLoad}qaPrefValidation`;

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: header,
    body: formData,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getCheckModalDropdownValues = async (dropdown) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  let endpoint = '';

  switch (dropdown) {
    case 'VPS': //will return importer/exporter
      endpoint = `${urlForNewLoad}qaPrefValidityDropdown`;
      break;
    case 'SMOB': //will return yes / no
      endpoint = `${urlForNewLoad}qaPrefImpExpDropdown`;
      break;

    default:
      break;
  }

  //make a get request to the backend
  const response = await fetch(endpoint, {
    method: 'GET',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

// Preference Claim dropdown (EU / RoW) - CABS-XXX
export const getPreferenceClaimDropdown = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  const endpoint = `${urlForNewLoad}qaPrefClaimDropdown`;

  const response = await fetch(endpoint, {
    method: 'GET',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

/*
retrieves the list of BP from the DB (POST neenor/partner - unchanged)
*/
export const postBusinessPartnerList = async (submit) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForNeeNor + 'partner', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(submit),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

/*============================================== */

export const postCm8CheckDuplicates = async (formData) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForCustomaite + 'checkDuplicates', {
    method: 'POST',
    headers: header,
    body: formData,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const updateDossierStatus = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  //post request to the CABIE backend
  const response = await fetch(urlForCustomaite + 'updatedossierstatus', {
    method: 'POST',
    headers: header,
    body: data,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postCustomaiteInfo = async (formData) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  try {
    const response = await fetch(`${urlForCustomaite}createNewDossier`, {
      method: 'POST',
      body: formData,
      headers: header,
    });

    if (response.status >= 400) {
      throw new Error('Network request failed');
    }

    return await response.json();
  } catch (error) {
    return { error: 'Server Unavailable' };
  }
};

export const postBusinessPartnerDocument = async (formData) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(`${urlBusinessPartner}fileUpload`, {
    method: 'POST',
    body: formData,
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

//function to get the Business Partner data from the backend
export const putBusinessPartner = async (data, activeStep, businessPartnerId) => {
  const isTest = false;
  let tabToUpdate = '';
  switch (activeStep) {
    case 'BPcompanydetails':
      tabToUpdate = 'companyDetails';
      break;
    case 'BPaddress':
      tabToUpdate = 'address';
      break;
    case 'BPContacts':
      tabToUpdate = 'contacts';
      break;
    case 'BPBillingDetails':
      tabToUpdate = 'billingDetails';
      break;
    case 'BPCustomsAndCompliance':
      tabToUpdate = 'customsCompliance';
      break;
    case 'BPCabie':
      tabToUpdate = 'traderData';
      break;
    default:
      break;
  }
  const endpoint = `${urlBusinessPartner}${tabToUpdate}?id=${businessPartnerId}`;
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  if (isTest) {
    // Simulate server delay
    return new Promise((resolve, reject) => {
      let returnData = {};
      setTimeout(() => {
        returnData = data;
        resolve(returnData);
      }, 2000);
    });
  } else {
    const trimmedData = trimObjectStrings(data);
    const response = await fetch(endpoint, {
      method: 'PUT',
      headers: header,
      body: JSON.stringify(trimmedData),
    });
    if (response.status >= 400) {
      throw new Error('Network request failed');
    } else {
      return await response.json();
    }
  }
};

/**
 * DELETE a single business partner contact by contact id.
 * Backend: DELETE /businesspartner/deleteContact?id={contactId}&neenorId={neenorId}
 */
export const deleteBusinessPartnerContact = async (contactId, neenorId) => {
  const endpoint = `${urlBusinessPartner}deleteContact?id=${contactId}&neenorId=${neenorId}`;
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(endpoint, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return response.json ? await response.json() : {};
};

export const getOrderForms = async (loadId) => {
  const endpoint = `${urlForNewLoad}getOrderForms?loadId=${loadId}`;
  const token = sessionStorage.getItem('token');

  const header = {
    Authorization: `${token}`,
  };

  const response = await fetch(endpoint, {
    method: 'get',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getBusinessParnerDocumentTypeDropdown = async () => {
  const endpoint = `${urlBusinessPartner}loadtype`;
  const token = sessionStorage.getItem('token');

  const header = {
    Authorization: `${token}`,
  };

  const response = await fetch(endpoint, {
    method: 'get',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getBusinessParnerDocumentDescriptionDropdown = async () => {
  const endpoint = `${urlBusinessPartner}loadDescription`;
  const token = sessionStorage.getItem('token');

  const header = {
    Authorization: `${token}`,
  };

  const response = await fetch(endpoint, {
    method: 'get',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getBusinessParnerDocumentDetails = async (documentId) => {
  const endpoint = `${urlBusinessPartner}documentdetails?id=${documentId}`;
  const token = sessionStorage.getItem('token');

  const header = {
    Authorization: `${token}`,
  };

  const response = await fetch(endpoint, {
    method: 'get',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getBusinessParnerDocumentsList = async (companyId) => {
  const endpoint = `${urlBusinessPartner}documentlist?id=${companyId}`;
  const token = sessionStorage.getItem('token');

  const header = {
    Authorization: `${token}`,
  };

  const response = await fetch(endpoint, {
    method: 'get',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getBusinessParnerAvailableDocumentsList = async (companyId) => {
  const endpoint = `${urlBusinessPartner}availabledocumentlist?id=${companyId}`;
  const token = sessionStorage.getItem('token');

  const header = {
    Authorization: `${token}`,
  };

  const response = await fetch(endpoint, {
    method: 'get',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getBusinessPartnerStatus = async (id) => {
  const endpoint = `${urlBusinessPartner}bpStatus?id=${id}`;
  const token = sessionStorage.getItem('token');

  const header = {
    Authorization: `${token}`,
  };

  const response = await fetch(endpoint, {
    method: 'get',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

/*function to get dropdown values for the Business Partner data from the backend
params:
dropdownvalue: string - the name of the dropdown we want to fetch the values for

returns:
response: object - the response from the API call, containing the values for the selected dropdown
==================================================================*/
export const getBusinessParnerDropdownValues = async (dropdownvalue) => {
  let endpoint = '';
  switch (dropdownvalue) {
    case 'CABIE Status':
      endpoint = `${urlBusinessPartner}CABIEStatusDropdown`;
      break;
    case 'Secondary Status':
      endpoint = `${urlBusinessPartner}SecondaryStatusDropdown`;
      break;
    case 'Standing Authority':
      endpoint = `${urlBusinessPartner}StandingAuthorityStatusDropdown`;
      break;
    case 'FFD MoP':
      endpoint = `${urlBusinessPartner}FFDMoPOptionsDropdown`;
      break;
    case 'Valuation Method':
      endpoint = `${urlBusinessPartner}ValuationMethodDropdown`;
      break;
    case 'Representation Type':
      endpoint = `${urlBusinessPartner}RepresentationTypeDropdown`;
      break;
    case 'Representative':
      endpoint = `${urlBusinessPartner}RepresentativeDropdown`;
      break;
    case 'Restrict VAT Options':
      endpoint = `${urlBusinessPartner}VATRestrictionsDropdown`;
      break;
    case 'Country':
      endpoint = `${urlForNewLoad}countrycodesNeenor`;
      break;
    case 'Billable Type':
      endpoint = `${urlBusinessPartner}billableTypeDropdown`;
      break;
    case 'SLA':
      endpoint = `${urlBusinessPartner}slaDropdown`;
      break;
    case 'Type':
      endpoint = `${urlBusinessPartner}typeDropdown`;
      break;
    default:
      throw new Error('Invalid endpoint for dropdown values');
  }
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  const response = await fetch(endpoint, {
    method: 'get',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getDutyAdminDropdown = async (businessPartnerId, charged = 0) => {
  const endpoint = `${urlBusinessPartner}dutyAdminDropdown?charged=${charged}&id=${businessPartnerId || 0}`;
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(endpoint, {
    method: 'get',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

//function to get the Business Partner data from the backend
export const getBusinessPartner = async (title, businessPartnerId, isTest) => {
  let endpoint = '';
  switch (title) {
    case 'Company':
      endpoint = `${urlBusinessPartner}company?id=${businessPartnerId}`;
      break;
    case 'Main Contact Details':
      endpoint = `${urlBusinessPartner}mainContactDetails?id=${businessPartnerId}`;
      break;
    case 'Business Partner':
      endpoint = `${urlBusinessPartner}businessPartner?id=${businessPartnerId}`;
      break;
    case 'Address':
      endpoint = `${urlBusinessPartner}address?id=${businessPartnerId}`;
      break;
    case 'Contacts':
      if (!businessPartnerId) {
        return Array.from({ length: 5 }, () => ({ contactName: '', contactEmail: '' }));
      }
      endpoint = `${urlBusinessPartner}contacts?id=${businessPartnerId}`;
      break;
    case 'Billable Settings':
      endpoint = `${urlBusinessPartner}billableSettings?id=${businessPartnerId}`;
      break;
    case 'Company Payment Details':
      endpoint = `${urlBusinessPartner}companyPaymentDetails?id=${businessPartnerId}`;
      break;
    case 'Authorisation Documents':
      endpoint = `${urlBusinessPartner}authorisationDocuments?id=${businessPartnerId}`;
      break;
    case 'Customs Authorisations':
      endpoint = `${urlBusinessPartner}customsAuthorisations?id=${businessPartnerId}`;
      break;
    case 'tabs info':
      endpoint = `${urlBusinessPartner}PartnerStatus?id=${businessPartnerId}`;
      break;
    case 'Trader Data':
      endpoint = `${urlBusinessPartner}traderData?id=${businessPartnerId}`;
      break;
    case 'Trader Settings':
      endpoint = `${urlBusinessPartner}traderSettings?id=${businessPartnerId}`;
      break;
    case 'Parents':
      endpoint = `${urlBusinessPartner}ParentById?id=${businessPartnerId}&onlyChecked=0`;
      break;
    default:
      endpoint = `${urlBusinessPartner}company?id=${businessPartnerId}`;
      break;
  }
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  const response = await fetch(endpoint, {
    method: 'get',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    const responseJson = await response.json();
    return trimObjectStrings(responseJson);
  }
};

export const deleteBusinessPartnerDocument = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: token,
    'Content-Type': 'application/json',
  };
  const response = await fetch(`${urlBusinessPartner}deleteDocument?id=${id}`, {
    method: 'DELETE',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const putBusinessPartnerRestoreDocument = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(`${urlBusinessPartner}restoreDocument?id=${id}`, {
    method: 'PUT',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

//function to save the parent relations for a business partner
export const putBusinessPartnerParents = async (parentIds, businessPartnerId) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(`${urlBusinessPartner}parents?id=${businessPartnerId}`, {
    method: 'PUT',
    headers: header,
    body: JSON.stringify({ parentIds }),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

//function to get the dashboard data from the report API
export const getDashboardReport = async (data) => {
  const istest = false;
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  if (istest) {
    // Simulate server delay
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // Test JSON
        const testJson = {
          key: urlForReportDashboard,
          // Add more key-value pairs as needed
        };

        resolve(testJson);
      }, 2000); // Delay for 2 seconds
    });
  } else {
    const response = await fetch(urlForReportDashboard, {
      //TODO: change this to the correct endpoint
      method: 'GET',
      headers: header,
    });
    if (response.status >= 400) {
      throw new Error('Network request failed');
    } else {
      return await response.json();
    }
  }
};

export const getCommcodeRefreshTable = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForCommcode + 'refreshTable', {
    headers: header,
    method: 'GET',
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getUpdateCommcodeSingle = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForCommcode + 'single?id=' + id, {
    headers: header,
    method: 'GET',
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getUpdateCommcodeAll = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForCommcode + 'all', {
    headers: header,
    method: 'GET',
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const delCommcodeSingle = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(`${urlForCommcode}single?id=${id}`, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const putCommcodeSingle = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForCommcode + 'single?id=' + id, {
    method: 'PUT',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return true;
};

export const postSelectedReport = async (data, fd) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForSelectedReport + data, {
    method: 'POST',
    headers: header,
    body: fd,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getReportsDropdown = async (id, data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForReportList + data + '?id=' + id, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getSingleReport = async (data, id) => {
  let reportName = '';
  if (id) {
    reportName = id;
  }
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForReportList + `${data}?reportName=${reportName}`, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getReportList = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForReportList + 'reportList', {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postEPOMovementDirection = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + 'epoMovementDirection', {
    method: 'POST',
    body: data,
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postEPOExport = async (endPoint, data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + endPoint, {
    method: 'POST',
    body: data,
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getEPOPortDropdown = async (data, id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + 'port' + '?import=' + data + '&directionid=' + id, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getEPOSiteNames = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + 'SiteNames', {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getEpoForm = async (endPoint, id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + endPoint + '?id=' + id, {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getEpoDropdown = async (id, data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + data + '?id=' + id, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getCompanyList = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForCompanyList, {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const updateUserStatus = async (endpoint, userIds) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: token,
    'Content-Type': 'application/json',
  };
  const response = await fetch(`${urlForUserAdmin}${endpoint}`, {
    method: 'POST',
    headers: header,
    body: JSON.stringify(userIds),
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const updateCompanyName = async (id, name) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: token,
    'Content-Type': 'application/json',
  };
  const response = await fetch(`${urlForUserAdmin}updateCompanyName`, {
    method: 'POST',
    headers: header,
    body: JSON.stringify({ id, name }),
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const updateDepartmentAndRole = async (userIds, department, role) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: token,
    'Content-Type': 'application/json',
  };
  const response = await fetch(`${urlForUserAdmin}updateDepartmentAndRole`, {
    method: 'POST',
    headers: header,
    body: JSON.stringify({ userIds, department, role }),
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const updateRole = async (userIds, role) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: token,
    'Content-Type': 'application/json',
  };
  const response = await fetch(`${urlForUserAdmin}updateRole`, {
    method: 'POST',
    headers: header,
    body: JSON.stringify({ userIds, role }),
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postAdminPasswordreset = async (formData) => {
  const response = await fetch(`${urlForUserAdmin}${'sendemail'}`, {
    method: 'POST',
    body: formData,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getDDAStatus = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + 'DDA?id=' + id, {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postCertsList = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + 'certs', {
    method: 'POST',
    body: data,
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getLspTradersIDs = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + 'lspTraders', {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getChed = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + 'ched?id=' + id, {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getSubtasks = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  const response = await fetch(urlForListLoads + 'subTask', {
    method: 'GET',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const addSubtask = async (newLoadId, subTask, isEpo = false) => {
  const body = {
    newLoadId: parseInt(newLoadId),
    subTaskId: parseInt(subTask),
    isEpo: isEpo ? 1 : 0,
    isSubTask: true,
  };

  return await backendFetch({
    url: 'listload/subTask',
    method: 'POST',
    options: {
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
  });
};

export const deleteChed = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + 'ched?id=' + id, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postNewWLP = async (submitData) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForUserAdmin + 'newwlp', {
    method: 'POST',
    body: submitData,
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getWLPTraders = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForWLP + 'traders', {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};
export const getWLPLsp = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForWLP + 'lsps', {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getWLPLoads = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForWLP + 'loads', {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getWLPRelationships = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForWLP + 'relationships?id=' + id, {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getNominatedUsers = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForLspAccess, {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getNominatedUserDetails = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForLspAccess + 'details?id=' + id, {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postNominatedUserSearch = async (data) => {
  return [
    { id: 1, firstName: 'Joe', lastName: 'Bloggs', email: 'joe.bloggs@aol.com', eoriNumber: 'GB123' },
    { id: 2, firstName: 'Ben', lastName: 'Smith', email: 'ben.bloggs@aol.com', eoriNumber: 'ABC011' },
  ];
};

export const postNominatedUser = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForLspAccess, {
    method: 'POST',
    body: data,
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getGATrackingCode = async () => {
  const response = await fetch(urlForGATrackingCode, {
    method: 'GET',
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postNBPNotes = async (formData) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForBusinessPartnerAddNote, {
    method: 'POST',
    body: formData,
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const deleteNBPNote = async (noteId, customerId) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(
    urlForBusinessPartnerDeleteNote.replace('{id}', noteId).replace('{customerId}', customerId),
    {
      method: 'DELETE',
      headers: header,
    }
  );
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return 'success';
  }
};

export const getNBPNotes = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForBusinessPartnerGetNotes + id, {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postAdditionalEPOFile = async (formData) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  const response = await fetch(urlForAdditionalEPOFileUpload, {
    method: 'POST',
    body: formData,
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const fetch = async (...args) => {
  const pathname = new URL(window.location.href).pathname.toLowerCase();
  return window.fetch(...args).then(async (resp) => {
    // If token has expired; force re-auth.
    if (resp.status === 401) {
      logout();
      const q = new URLSearchParams();
      q.append('authError', 'Session expired, please log in again.');
      if (!pathname.startsWith('/login')) {
        window.location.assign('/login?' + q.toString());
      }
      return;
    }
    // If user is forbidden; redirect away from page.
    if (resp.status === 403) {
      const q = new URLSearchParams();
      q.append('authError', "Sorry, you don't have permission to do that.");
      if (!pathname.startsWith('/main')) {
        window.location.assign('/main?' + q.toString());
      }
      return;
    }

    if (resp.status === 400 && resp.url === url + 'forgottenpassword/resetpassword') {
      return Promise.resolve(resp);
    }
    if (resp.ok) {
      return resp;
    } else {
      const error = await resp.text();
      return Promise.reject(new Error(error));
    }
  });
};

export const postDocusignPage = async (formData) => {
  const response = await fetch(urlForDocusign, {
    method: 'POST',
    body: formData,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const putDocusignSigned = async (state, existingCustomer, event) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  const fd = new FormData();
  fd.append('state', state);
  fd.append('existingCustomer', existingCustomer === true || existingCustomer === 'true');
  fd.append('event', event);
  const response = await fetch(urlForRegistration + 'signed', {
    method: 'PUT',
    headers: header,
    body: fd,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return 'success';
};

export const postDocusignReopen = async (envelopeId) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  const fd = new FormData();
  fd.append('envelopeId', envelopeId);
  const response = await fetch(urlForRegistration + 'reopenEnvelope', {
    method: 'POST',
    headers: header,
    body: fd,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return response.json();
};

export const postDocusignResend = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  const fd = new FormData();
  fd.append('state', id);
  const response = await fetch(urlForRegistration + 'resendEnvelope', {
    method: 'POST',
    headers: header,
    body: fd,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return response.json();
};

export const getDocumentTypes = async () => {
  const response = await fetch(urlForDocumentTypes);
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};
export const getAdditionalFileData = async (documentID) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForAdditionalFileData + '?documentID=' + documentID, {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.blob();
};

export const getAdditionalFileNames = async (newLoadID) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForAdditionalFileNames + '?newLoadID=' + newLoadID, {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postAdditionalFileUpload = async (formdata) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForAdditionalFileUpload, {
    method: 'POST',
    headers: header,
    body: formdata,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return 'success';
};

export const deleteAdditionalFileUpload = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForAdditionalFileDelete + '?id=' + id, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return 'success';
  }
};

export const getPortProcessDropdown = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForNewLoad + data, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getCutomerData = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForCustomerData, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const putCutomerData = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForCustomerData, {
    method: 'PUT',
    body: dataform,
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return true;
};

export const postCutomerData = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForCustomerData, {
    method: 'POST',
    body: dataform,
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getCutomerDataDetails = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForCustomerData + '/details?id=' + id, {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const deleteCutomerData = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForCustomerData + '?id=' + id, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getEidr = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEIDR + data, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postSDISubmit = async (submit) => {
  const token = sessionStorage.getItem('token');
  const body = JSON.stringify(submit);
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForSDI, {
    method: 'POST',
    headers: header,
    body: body,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postSFDSubmit = async (submit) => {
  const token = sessionStorage.getItem('token');
  const body = JSON.stringify(submit);
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForSFD, {
    method: 'POST',
    headers: header,
    body: body,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postFFDSubmit = async (submit) => {
  const token = sessionStorage.getItem('token');
  const body = JSON.stringify(submit);
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForFFD, {
    method: 'POST',
    headers: header,
    body: body,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postC21Submit = async (submit) => {
  const token = sessionStorage.getItem('token');
  const body = JSON.stringify(submit);
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForC21, {
    method: 'POST',
    headers: header,
    body: body,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postEADSubmit = async (submit) => {
  const token = sessionStorage.getItem('token');
  const body = JSON.stringify(submit);
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForEAD, {
    method: 'POST',
    headers: header,
    body: body,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postFileUpload = async (url, file) => {
  const dataform = file;
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForFileUpload + url, {
    method: 'POST',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postActivated = async (submit) => {
  const dataform = new FormData(submit);
  const response = await fetch(urlForMasterData + 'activated', {
    method: 'POST',
    body: dataform,
  });
  if (response.status >= 400) {
    sessionStorage.setItem('loggedIn', 'failed');
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postActivatedAndReset = async (submit) => {
  const dataform = new FormData(submit);
  const response = await fetch(urlForMasterData + 'activateAndReset', {
    method: 'POST',
    body: dataform,
  });
  if (response.status >= 400) {
    sessionStorage.setItem('loggedIn', 'failed');
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const putPasswordreset = async (submit) => {
  const dataform = new FormData(submit);
  const response = await fetch(urlForForgottenpassword + 'resetpassword', {
    method: 'PUT',
    body: dataform,
  });
  if (response.status >= 400) {
    sessionStorage.setItem('loggedIn', 'failed');
    return await response.json();
  }
  return await response.json();
};

export const verifyOneTimePassword = async (submit) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  const dataform = new FormData(submit);
  const response = await fetch(urlForVerifyOneTimePassword, {
    method: 'POST',
    headers: header,
    body: dataform,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const requestNewOneTimePassword = async (submit) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  const response = await fetch(urlForRequestNewOneTimePassword, {
    method: 'POST',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const addUser = async (submit) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForAddUser, {
    method: 'POST',
    headers: header,
    body: submit,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getCompanys = async (type) => {
  const response = await fetch(urlForCompanys);
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};
export const invoiceSearch = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForinvoiceSearch, {
    method: 'POST',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getInvoiceDetails = async (invoice) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForinvoiceDetails + invoice, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getTeamMemberDetails = async (invoice) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForTeamMemberDetails + invoice, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const deleteTeamMemberDetails = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForTeamMembers + '?id=' + id, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postTeamMemberDetails = async (submit, data) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForUserAdmin + data, {
    method: 'POST',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getTeamMembers = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForTeamMembers, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};
export const postTeamMembers = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForTeamMembers, {
    method: 'POST',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const putTeamMembers = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForTeamMembers, {
    method: 'PUT',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const checkEORIvalid = async (eori) => {
  const response = await fetch(urlFroValidateEORI + eori.toUpperCase());
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const checkVatValid = async (vat) => {
  const response = await fetch(urlForValidateVAT + vat);
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postproductData = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForProductdata, {
    method: 'POST',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const masterData = async (submit) => {
  const dataform = new FormData(submit);
  const response = await fetch(urlForMasterData, {
    method: 'POST',
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getMasterData = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMasterData, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const checkProductvalid = async (product) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlFroValidateProduct + product, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getProductsForCompany = async (companyId) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForCompanyProducts + '?companyId=' + companyId, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getImportExport = async (id, type) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForNewLoad + 'importexport?id=' + id + '&type=' + type, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getProducts = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForProducts, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postProducts = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForProducts, {
    method: 'POST',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getNeeNor = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForNeeNor, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};
export const postNeeNor = async (submit) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForNeeNor, {
    method: 'POST',
    headers: header,
    body: JSON.stringify(submit),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getReports = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForReports + data, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getReportDetails = async (data, id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForReports + data + '?directionid=' + id, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getListLoad = async (data, id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  const response = await fetch(urlForListLoads + data + '?id=' + id, {
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getNewLoad = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForNewLoad + data, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getNewLoadNeeNor = async (id, type) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForNewLoad + 'neenor?id=' + id + '&type=' + type, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getCompanyRepresentativeStatus = async (companyId) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForNewLoad + 'companyRepresentative?companyId=' + companyId, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getUsers = async (data, id) => {
  let companyId = '';
  if (id) {
    companyId = id;
  }
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForUserAdmin + `${data}?companyId=${companyId}`, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const putUsersDownload = async (data, id) => {
  let companyId = '';
  if (id) {
    companyId = id;
  }
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForUserAdmin + `${data}?companyId=${companyId}`, {
    method: 'PUT',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getUsersSearch = async (body) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForUserAdmin + 'advancedSearch', {
    headers: header,
    method: 'POST',
    body: JSON.stringify(body ?? {}),
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getNewLoadProcesses = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForNewLoad + data, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getUserDetails = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForUserDetails + data, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postUserDetails = async (fd) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForUserAdmin + 'add', {
    method: 'POST',
    headers: header,
    body: fd,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postUsers = async (submit, data) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForUserAdmin + data, {
    method: 'POST',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getNewLoadDetails = async (data, id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  const response = await fetch(urlForNewLoad + data + '?directionid=' + id, {
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getNewLoadDropdown = async (data, id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForNewLoad + data + '?directionid=' + id, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getNewLoadNeeNorDropdown = async (data, id, type, search, skip, rpaID) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(
    urlForNewLoad +
      data +
      '?id=' +
      id +
      '&type=' +
      type +
      (search ? '&search=' + encodeURIComponent(search) : '') +
      (skip ? '&skip=' + skip : '') +
      (rpaID ? '&rpaID=' + rpaID : ''),
    {
      headers: header,
    }
  );
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getNewLoadNeeDropdown = async (data, id, type, search, skip, rpaID) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(
    urlForEPOData +
      'neenor' +
      '?id=' +
      id +
      '&type=' +
      type +
      (search ? '&search=' + search : '') +
      (skip ? '&skip=' + skip : '') +
      (rpaID ? '&rpaID=' + rpaID : ''),
    {
      headers: header,
    }
  );
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getDestCountryOptions = async (isImport, newLoadId) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + 'despDest' + '?import=' + isImport + '&id=' + newLoadId, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postListLoad = async (data, url) => {
  const token = sessionStorage.getItem('token');
  const body = JSON.stringify(data);
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };

  const response = await fetch(urlForListLoads + url, {
    method: 'POST',
    headers: header,
    body: body,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postNewLoad = async (submit, url) => {
  const token = sessionStorage.getItem('token');
  const body = JSON.stringify(submit);
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };

  const response = await fetch(urlForNewLoad + url, {
    method: 'POST',
    headers: header,
    body: body,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    if (url === 'validation') {
      const responseJson = await response.json();
      // responseJson[0]['catchCertError'] = 'This is a test error for catch Cert'; //TODO: remove this when the backend is ready
      return responseJson;
    }
    return await response.json();
  }
};

export const postNewLoadSearch = async (dataform, url) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForNewLoad + url, {
    method: 'POST',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postNewloadLazyLoad = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };

  const response = await fetch(urlForNewLoad + 'lazyLoad', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(data),
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getNeeNorDetails = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForNeeNorDetails + id, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const deleteNeeNorDetails = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForNeeNor + '?id=' + id, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const putNeeNor = async (submit) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForNeeNor, {
    method: 'PUT',
    headers: header,
    body: JSON.stringify(submit),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postNeeNorSearch = async (submit) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForNeeNor + 'search', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(submit),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postNeeNorLazyLoad = async (submit) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForNeeNor + 'lazy', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(submit),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getNewLoadQaComplianceChecklist = async (id, incoterm = '') => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(`${urlForNeeNor}status?id=${id}&incoterm=${incoterm}`, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getProductDetails = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForPruductsDetails + id, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const deleteProductDetails = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForProducts + '?id=' + id, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const putProduct = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForProducts, {
    method: 'PUT',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postProductsSearch = async (submit) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForProducts + '/search', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(submit),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const deletUserDetails = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForUserAdmin + '?id=' + id, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const restoreUserDetails = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForUserAdmin + 'restore/?id=' + id, {
    method: 'GET',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const putUserDetails = async (fd) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForUserAdmin, {
    method: 'PUT',
    headers: header,
    body: fd,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const putMasterData = async (fd) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMasterData, {
    method: 'PUT',
    headers: header,
    body: fd,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting master data.');
  }
  return await response.json();
};

export const deleteCommCode = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'commcode' + '?id=' + id, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error deleting commodity code.');
  } else {
    return await response.json();
  }
};

export const putCommCode = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'commcode', {
    method: 'PUT',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting commodity code.');
  }
  return await response.json();
};

export const getCommCode = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'commcode', {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving commodity code.');
  }
  return await response.json();
};

export const postCommCode = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'commcode', {
    method: 'POST',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting commodity code.');
  }
  return await response.json();
};

export const getCommCodeDetail = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'commcodeDetail' + '?id=' + id, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving commodity code.');
  }
  return await response.json();
};

export const deleteMovementType = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'movement' + '?id=' + id, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error deleting movement type.');
  } else {
    return await response.json();
  }
};

export const putMovementType = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'movement', {
    method: 'PUT',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting movement type.');
  }
  return await response.json();
};

export const getMovementType = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'movement', {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving movement type.');
  }
  return await response.json();
};

export const postMovementType = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'movement', {
    method: 'POST',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting movement type.');
  }
  return await response.json();
};

export const getMovementTypeDetail = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'movementDetail' + '?id=' + id, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving movement type.');
  }
  return await response.json();
};

export const deleteCompanyLoad = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companyload' + '?id=' + id, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error deleting company load.');
  } else {
    return await response.json();
  }
};

export const putCompanyLoad = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companyload', {
    method: 'PUT',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting company load.');
  }
  return await response.json();
};

export const getCompanyLoad = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companyload', {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving company load.');
  }
  return await response.json();
};

export const postCompanyLoad = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companyload', {
    method: 'POST',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting company load.');
  } else {
    return await response.json();
  }
};

export const getCompanyLoadDetail = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companyloaddetail' + '?id=' + id, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving company load.');
  }
  return await response.json();
};

// New Master Data API endpoints with pagination
export const getMasterDataLoadType = async (pageNumber = 1, pageSize = 100, includeDeleted = 0) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(
    urlForMasterData + `loadType?pageNumber=${pageNumber}&pageSize=${pageSize}&includeDeleted=${includeDeleted}`,
    {
      headers: header,
    }
  );
  if (response.status >= 400) {
    throw new Error('Error retrieving load types.');
  }
  return await response.json();
};

export const upsertMasterDataLoadType = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForMasterData + 'loadType', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(data),
  });
  if (response.status >= 400) {
    throw new Error('Error saving load type.');
  }
  return await response.json();
};

export const getMasterDataCurrency = async (pageNumber = 1, pageSize = 100, includeDeleted = 0) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(
    urlForMasterData + `currency?pageNumber=${pageNumber}&pageSize=${pageSize}&includeDeleted=${includeDeleted}`,
    {
      headers: header,
    }
  );
  if (response.status >= 400) {
    throw new Error('Error retrieving currencies.');
  }
  return await response.json();
};

export const upsertMasterDataCurrency = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForMasterData + 'currency', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(data),
  });
  if (response.status >= 400) {
    throw new Error('Error saving currency.');
  }
  return await response.json();
};

export const getMasterDataCountry = async (pageNumber = 1, pageSize = 100, includeDeleted = 0) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(
    urlForMasterData + `country?pageNumber=${pageNumber}&pageSize=${pageSize}&includeDeleted=${includeDeleted}`,
    {
      headers: header,
    }
  );
  if (response.status >= 400) {
    throw new Error('Error retrieving countries.');
  }
  return await response.json();
};

export const upsertMasterDataCountry = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForMasterData + 'country', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(data),
  });
  if (response.status >= 400) {
    throw new Error('Error saving country.');
  }
  return await response.json();
};

export const getMasterDataPort = async (pageNumber = 1, pageSize = 100, includeDeleted = 0) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(
    urlForMasterData + `port?pageNumber=${pageNumber}&pageSize=${pageSize}&includeDeleted=${includeDeleted}`,
    {
      headers: header,
    }
  );
  if (response.status >= 400) {
    throw new Error('Error retrieving ports.');
  }
  return await response.json();
};

export const getMasterDataEpoAreaCode = async (pageNumber = 1, pageSize = 100, includeDeleted = 0) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(
    urlForMasterData + `epoAreaCode?pageNumber=${pageNumber}&pageSize=${pageSize}&includeDeleted=${includeDeleted}`,
    {
      headers: header,
    }
  );
  if (response.status >= 400) {
    throw new Error('Error retrieving area codes.');
  }
  return await response.json();
};

export const deleteCompanyCountry = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companycountry' + '?id=' + id, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error deleting company country.');
  } else {
    return await response.json();
  }
};

export const putCompanyCountry = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companycountry', {
    method: 'PUT',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting company country.');
  }
  return await response.json();
};

export const getCompanyCountry = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companycountry', {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving company country.');
  }
  return await response.json();
};

export const postCompanyCountry = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companycountry', {
    method: 'POST',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting company country.');
  }
  return await response.json();
};

export const getCompanyCountryDetail = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companycountrydetail' + '?id=' + id, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving company country.');
  }
  return await response.json();
};

export const deleteCompanyPorts = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companyports' + '?id=' + id, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error deleting company ports.');
  } else {
    return await response.json();
  }
};

export const putCompanyPorts = async (submit) => {
  const dataform = buildPortsFormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companyports', {
    method: 'PUT',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting company ports.');
  }
  return await response.json();
};

export const getCompanyPorts = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companyports', {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving company ports.');
  }
  return await response.json();
};

export const postCompanyPorts = async (submit) => {
  const dataform = buildPortsFormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companyports', {
    method: 'POST',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting company ports.');
  }
  return await response.json();
};

export const getCompanyPortsDetail = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companyportsdetail' + '?id=' + id, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving company ports.');
  }
  return await response.json();
};

/**
 * Lazy-load company ports with server-side pagination, sorting and filtering.
 * @param {{ skip: number, amount: number, sort_by?: string, sort_order?: string, filter?: Record<string, any> }} payload
 * @returns {Promise<{ data: any[], totalItems: number }>} Backend may return array only; then totalItems = data.length.
 */
export const postCompanyPortsLazy = async (payload) => {
  const token = sessionStorage.getItem('token');
  const header = {
    'Content-Type': 'application/json',
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companyportsLazy', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(payload),
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving company ports.');
  }
  const result = await response.json();
  if (Array.isArray(result)) {
    const totalItems =
      result.length > 0 && typeof result[0].totalCount === 'number' ? result[0].totalCount : result.length;
    const data = result.map(({ totalCount, ...row }) => row);
    return { data, totalItems };
  }
  return { data: result.data ?? result.recordset ?? [], totalItems: result.totalItems ?? result.totalCount ?? 0 };
};

export const deleteShipStatus = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'shipstatus' + '?id=' + id, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error deleting ship status.');
  } else {
    return await response.json();
  }
};

export const putShipStatus = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'shipstatus', {
    method: 'PUT',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting ship status.');
  }
  return await response.json();
};

export const getShipStatus = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'shipstatus', {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving ship status.');
  }
  return await response.json();
};

export const postShipStatus = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'shipstatus', {
    method: 'POST',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting ship status.');
  }
  return await response.json();
};

export const getShipStatusDetail = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'shipstatusdetail' + '?id=' + id, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving ship status.');
  }
  return await response.json();
};

export const deleteCompanyCurrency = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companycurrency' + '?id=' + id, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error deleting company currency.');
  } else {
    return await response.json();
  }
};

export const putCompanyCurrency = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companycurrency', {
    method: 'PUT',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting company currency.');
  }
  return await response.json();
};

export const getCompanyCurrency = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companycurrency', {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving company currency.');
  }
  return await response.json();
};

export const postCompanyCurrency = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companycurrency', {
    method: 'POST',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting company currency.');
  }
  return await response.json();
};

export const getCompanyCurrencyDetail = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companycurrencydetail' + '?id=' + id, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving company currency.');
  }
  return await response.json();
};

export const deleteCompanyIncoterm = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companyincoterm' + '?id=' + id, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error deleting company incoterm.');
  } else {
    return await response.json();
  }
};

export const putCompanyIncoterm = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companyincoterm', {
    method: 'PUT',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting company incoterm.');
  }
  return await response.json();
};

export const getCompanyIncoterm = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companyincoterm', {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving company incoterm.');
  }
  return await response.json();
};

export const postCompanyIncoterm = async (submit) => {
  const dataform = new FormData(submit);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companyincoterm', {
    method: 'POST',
    headers: header,
    body: dataform,
  });
  if (response.status >= 400) {
    throw new Error('Error submitting company incoterm.');
  }
  return await response.json();
};

export const getCompanyIncotermDetail = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMaintenance + 'companyincotermdetail' + '?id=' + id, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving company incoterm.');
  }
  return await response.json();
};

export const postOrderForm = async (submit) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForOrderForm, {
    method: 'POST',
    headers: header,
    body: submit,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const putEPOStatus = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForEPOData + 'status', {
    method: 'PUT',
    headers: header,
    body: JSON.stringify(data),
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return true;
  }
};

export const updateEPOStatus = async (id) => {
  const fd = new FormData();
  fd.append('id', id);
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + 'UpdateEPOStatus', {
    method: 'POST',
    headers: header,
    body: fd,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postEPOHeaders = async (fd) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + 'Headers', {
    method: 'POST',
    headers: header,
    body: fd,
    // body: body
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const putArrivalDate = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForEPOData + 'Arrival', {
    method: 'PUT',
    headers: header,
    body: JSON.stringify(data),
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return true;
  }
};

export const postCommodityInfo = async (fd) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForCommodityInfo, {
    method: 'POST',
    headers: header,
    body: fd,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getEPO = async (id, url) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + url + '?id=' + id, {
    headers: header,
    method: 'GET',
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const searchEpoListLazy = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };

  const response = await fetch(urlForEPOData + 'searchLazy', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(data),
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getEPOStatuses = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + 'Status', {
    headers: header,
    method: 'GET',
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getCommodityDetail = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForCommodityInfo + '?id=' + id, {
    headers: header,
    method: 'GET',
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

// get all headers for company = getEPO(company Id, "Headers")
// get header and initial details associated on header screen = getEPO(Company new load id, "Header")
// get all invoice details = getEPO(Company New load id, "Invoices")
// get invoice document (Reporting service) = getEPOInvoice(Invoice Id)
// get item details for one invoice = getEPO(Invoice Id, "Item")
// get all items for header and totals = getEPO(Company new load id, "Items")

export const putEPO = async (data, url, id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForEPOData + url + '?id=' + id, {
    method: 'PUT',
    headers: header,
    body: JSON.stringify(data),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  let responseJson = await response.json();
  //responseJson = responseJson.map(obj => ({...obj, RGRWarn: 'testvalue', RGRValid: false, areaMatchValid: false, preferentialWarn: 'test on preferential'}));
  return await responseJson;
};
// update invoice status = putEPO((Status or filename?), "Invoice", invoiceid )
// update items for invoice = putEPO((items), "Items", invoiceid )

export const postVatRestrictions = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlBusinessPartner + 'vatRestrictions', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(data),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  let responseJson = await response.json();
  return await responseJson;
};

export const postAuthRevalidate = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForVatAuth, {
    method: 'POST',
    headers: header,
    body: JSON.stringify(data),
  });

  if (response.status >= 400) {
    sessionStorage.setItem('loggedIn', 'failed');
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const postSupplementaryUnits = async (items, gbImportFlag) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };

  const requestData = {
    items: items,
    gbImport: gbImportFlag,
  };

  const response = await fetch(urlForSupplementaryUnits, {
    method: 'POST',
    headers: header,
    body: JSON.stringify(requestData),
  });

  if (response.status >= 400) {
    sessionStorage.setItem('loggedIn', 'failed');
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const deleteEPO = async (id, url) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForEPOData + url + '?id=' + id, {
    method: 'DELETE',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return 'success';
  }
};
// delete EPO invoice = deleteEPO(invoice id, "Invoice")

export const getMeasureDetail = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForMeasuresInfo + '?id=' + id, {
    headers: header,
    method: 'GET',
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getCountryDetail = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForCountryInfo, {
    headers: header,
    method: 'GET',
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getEPOList = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForEPOData + 'List' + '?id=' + id, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Error retrieving EPO list.');
  }
  return await response.json();
};

export const getRegistrationMonthlyDecs = async () => {
  const response = await fetch(urlForRegistration + 'monthlyDecs', {
    method: 'GET',
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getRegistrationStatuses = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForRegistration + 'Status', {
    headers: header,
    method: 'GET',
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const checkEORIDuplicate = async (eori, email) => {
  const response = await fetch(
    urlForRegistration +
      'duplicate?eori=' +
      encodeURIComponent(eori.toUpperCase()) +
      '&email=' +
      encodeURIComponent(email)
  );

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postInternalRegistrationData = async (body) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForRegistration + 'internal', {
    method: 'POST',
    headers: header,
    body,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const checkNewloadDuplicate = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForNewLoad + 'duplicatecheck', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(data),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getNewLoadQaVat = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(`${urlForNewLoad}qaVat?id=${id}`, {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postRegistrationData = async (body) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForRegistration, {
    method: 'POST',
    headers: header,
    body,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getRegistrationList = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForRegistration + 'list', {
    method: 'get',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postRegistrationListSearch = async (body) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForRegistration + 'list', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(body ?? {}),
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postRegistrationListLazy = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForRegistration + 'listLazy', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(data),
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const getRegistrationDetails = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForRegistration + 'details?id=' + id, {
    method: 'get',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getEnvelopeStatus = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(urlForRegistration + 'envelopeStatus?id=' + id, {
    method: 'get',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getRegistrationType = async () => {
  const response = await fetch(urlForRegistration + 'registrationType');
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const putRegistrationDetails = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const trimmedData = trimObjectStrings(data);
  const response = await fetch(urlForRegistration + 'details', {
    method: 'PUT',
    headers: header,
    body: JSON.stringify({ data: trimmedData }),
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const putRegistrationCompliance = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const trimmedData = trimObjectStrings(data);
  const response = await fetch(urlForRegistration + 'compliance', {
    method: 'PUT',
    headers: header,
    body: JSON.stringify({ data: trimmedData }),
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const putRegistrationAddress = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const trimmedData = trimObjectStrings(data);
  const response = await fetch(urlForRegistration + 'address', {
    method: 'PUT',
    headers: header,
    body: JSON.stringify({ data: trimmedData }),
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const putRegistrationEmail = async (data) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const trimmedData = trimObjectStrings(data);
  const response = await fetch(urlForRegistration + 'email', {
    method: 'PUT',
    headers: header,
    body: JSON.stringify({ data: trimmedData }),
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const postSendActivationEmail = async (body) => {
  const data = { id: body.id, emailAddress: body.emailAddress };
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
  const response = await fetch(urlForRegistration + 'sendActivationEmail', {
    method: 'POST',
    headers: header,
    body: JSON.stringify({ data }),
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const deleteEPODocument = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: token,
    'Content-Type': 'application/json',
  };
  const response = await fetch(`${urlForEPOData}deleteDocument?id=${id}`, {
    method: 'DELETE',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const restoreEPODocument = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };
  const response = await fetch(`${urlForEPOData}restoreDocument?id=${id}`, {
    method: 'PUT',
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export const updateTransactionLoadUploadedDocumentStatus = async (id) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  const response = await fetch(`${urlForEPOData}updateUploadedDocumentStatus?id=${id}`, {
    method: 'PUT',
    headers: header,
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

/* CABS-1798 - API for CABIE Planned Maintenance banner */
export const getMaintenance = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  try {
    const response = await fetch(`${url}maintenance/app`, {
      method: 'GET',
      headers: header,
    });

    return (await response?.json()) || [];
  } catch (error) {
    console.error('Error in getMaintenance:', error);
    throw error;
  }
};

export const getMaintenanceBannerDetails = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  try {
    const response = await fetch(`${url}maintenance/details`, {
      method: 'GET',
      headers: header,
    });

    return await response.json();
  } catch (error) {
    console.error('Error in getMaintenanceBanner:', error);
    throw error;
  }
};

export const putMaintenanceBannerDetails = async (data) => {
  const token = sessionStorage.getItem('token');
  const formData = new FormData();
  formData.append('enabled', data.enabled);
  formData.append('bannerText', data.bannerText);
  formData.append('moreInfo', data.moreInfo);
  formData.append('startDate', data.startDate);
  formData.append('endDate', data.endDate);
  formData.append('visibility', data.visibility);

  const header = {
    Authorization: `${token}`,
  };

  try {
    const response = await fetch(`${url}maintenance/details`, {
      method: 'PUT',
      headers: header,
      body: formData,
    });

    return await response.json();
  } catch (error) {
    console.error('Error in getMaintenanceBanner:', error);
    throw error;
  }
};

export const getExchangeRate = async (currency, date) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  const params = [];
  if (currency) {
    params.push(`currency=${currency}`);
  }
  if (date) {
    params.push(`date=${date}`);
  }

  const response = await fetch(urlForNewLoad + 'exchangeRate?' + params.join('&'), {
    headers: header,
  });
  if (response.status >= 400) {
    throw new Error('Network request failed');
  } else {
    return await response.json();
  }
};

export const getDutyRates = async (items, vatAdj = null, roiLoad = null) => {
  const token = sessionStorage.getItem('token');

  const header = {
    'Content-Type': 'application/json',
    Authorization: `${token}`,
  };

  const response = await fetch(urlForNewLoad + 'commodityDutyRates', {
    method: 'POST',
    headers: header,
    body: JSON.stringify({ items, vatAdjustment: vatAdj, ROILoad: roiLoad }),
  });

  if (response.status >= 400) {
    const errorText = await response.text();
    console.error('API Error Response:', errorText);
    throw new Error(`Network request failed: ${response.status} - ${errorText}`);
  }

  return await response.json();
};

export const postRexValidation = async (rexNumber) => {
  const token = sessionStorage.getItem('token');
  const header = {
    'Content-Type': 'application/json',
    Authorization: `${token}`,
  };
  const requestData = {
    items: rexNumber,
  };

  const response = await fetch(urlForNewLoad + 'validateRex', {
    method: 'POST',
    headers: header,
    body: JSON.stringify(requestData),
  });

  if (response.status >= 400) {
    const errorText = await response.text();
    console.error('API Error Response:', errorText);
    throw new Error(`Network request failed: ${response.status} - ${errorText}`);
  }

  return await response.json();
};

// return a list of load statuses (for Status dropdown in filters)
export const getLoadStatuses = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  try {
    const response = await fetch(urlForNewLoad + 'status', {
      method: 'GET',
      headers: header,
    });

    return await response.json();
  } catch (error) {
    console.error('Error in getLoadStatuses:', error);
    throw error;
  }
};

// return a list of load agents (for Agents dropdown in filters)
export const getLoadAgents = async () => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  try {
    const response = await fetch(urlForNewLoad + 'agents', {
      method: 'GET',
      headers: header,
    });

    return await response.json();
  } catch (error) {
    console.error('Error in getLoadAgents:', error);
    throw error;
  }
};

// return a list of load customers or traders (for Customer dropdown in filters)
export const getCustomersOrTraders = async (name = '', eori = '', skip = 10) => {
  const token = sessionStorage.getItem('token');
  const header = {
    'Content-Type': 'application/json',
    Authorization: `${token}`,
  };

  try {
    const response = await fetch(urlForNewLoad + 'customerOrTrader', {
      method: 'POST',
      headers: header,
      body: JSON.stringify({ searchCompany: name, searchEori: eori, skip }),
    });

    return await response.json();
  } catch (error) {
    console.error('Error in getCustomersOrTraders:', error);
    throw error;
  }
};

export const getDeclarationHistory = async (id, statusId) => {
  const token = sessionStorage.getItem('token');
  const header = {
    Authorization: `${token}`,
  };

  try {
    const response = await fetch(url + `listload/declarationLog?id=${id}&statusId=${statusId}`, {
      method: 'GET',
      headers: header,
    });

    return await response.json();
  } catch (error) {
    console.error('Error in getDeclarationHistory:', error);
    throw error;
  }
};

// *************************************************************
// *************************************************************
//
// Please don't add any new API calls in this file,
// instead add them in the new format to the /src/api folder
// See the Readme md file for how to add them
//
// *************************************************************
// *************************************************************
